import React, { useState } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text,
  VStack,
} from '@chakra-ui/react';
import CompanyActivityManager from './CompanyActivityManager';
import CompanySubTaskManager from './CompanySubTaskManager';

const CompanyMasterDataManager = () => {
  const [reloadKey, setReloadKey] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  // Force reload when switching tabs
  const handleTabChange = (index) => {
    setActiveTab(index);
    setReloadKey(prev => prev + 1); // Increment key to force reload
  };

  return (
    <Box>
      <VStack align="start" spacing={4} mb={6}>
        <Text fontSize="2xl" fontWeight="bold" color="white">
          Custom Master Data
        </Text>
        <Text fontSize="md" color="gray.400">
          Create and manage your company's custom activities and subtasks. These will be
          available alongside the global master data when creating project tasks.
        </Text>
      </VStack>

      <Tabs
        index={activeTab}
        onChange={handleTabChange}
        variant="soft-rounded"
        colorScheme="blue"
        bg="whiteAlpha.50"
        p={4}
        borderRadius="lg"
        border="1px solid"
        borderColor="whiteAlpha.200"
      >
        <TabList mb={4}>
          <Tab color="gray.300" _selected={{ color: 'white', bg: 'blue.500' }}>
            Activities
          </Tab>
          <Tab color="gray.300" _selected={{ color: 'white', bg: 'blue.500' }}>
            SubTasks
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <CompanyActivityManager key={`activity-${reloadKey}`} />
          </TabPanel>
          <TabPanel p={0}>
            <CompanySubTaskManager key={`subtask-${reloadKey}`} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default CompanyMasterDataManager;
